export default "/images/vendor/@coreui/icons/svg/flag/cif-kp.svg?1dd77c0a8c0a5475369c646b49a4a57e";